import { useContext, useMemo } from 'react';
import InlineButton from '../basics/InlineButton';
import { SHORTCUTS } from '../../constants/shortcuts';
import { captureEvent } from '../../utils/analytics';
import ButtonWithShortcut from '../basics/ButtonWithShortcut';
import { MapContext } from '../../contexts/MapContext';
import { useTilesetContext } from '../../contexts/TilesetContext';

interface Layer {
  shown: boolean;
}

interface ShowHideLayersProps {
  layers: Layer[];
  setClimateShown: (shown: boolean) => void;
  setLandUseShown: (shown: boolean) => void;
  setSuitabilityShown: (shown: boolean) => void;
}

const ShowHideLayersButton = ({
  layers,
  setClimateShown,
  setLandUseShown,
  setSuitabilityShown,
}: ShowHideLayersProps) => {
  const {
    // @ts-expect-error MapContext not migrated to TS
    layers: { bulkSetLayersShown },
  } = useContext(MapContext);
  const { setTilesetShown } = useTilesetContext();
  const shouldShow = useMemo(() => layers.some((layer) => !layer.shown), [
    layers,
  ]);
  const setLayersShown = (shown: boolean) => {
    bulkSetLayersShown({ shown });
    // Set tiles layer shown
    setTilesetShown(shown);
    // Set individual menus shown
    setClimateShown(shown);
    setLandUseShown(shown);
    setSuitabilityShown(shown);
  };
  return (
    <ButtonWithShortcut
      // @ts-expect-error ButtonWithShortcut not migrated to TS
      as={InlineButton}
      shortcut={SHORTCUTS.SHOW_HIDE_LAYERS.key}
      color="link"
      className="p-0 font-small text-muted align-self-end"
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        captureEvent('all-layers-visibility-toggled', { visible: shouldShow });
        setLayersShown(shouldShow);
      }}
    >
      {shouldShow ? 'Show' : 'Hide'} All
    </ButtonWithShortcut>
  );
};
export default ShowHideLayersButton;
